// extracted by mini-css-extract-plugin
export default {"root":"OnfYUmId3N"};